import XLSX from 'xlsx'
import moment from 'moment'

export default (filters, journeys, i18n) => {
  const lines = [
    [
      i18n.$t('supervision.metric.xls.region'),
      i18n.$t('supervision.metric.xls.start'),
      i18n.$t('supervision.metric.xls.finish'),
      i18n.$t('supervision.metric.xls.location'),
      i18n.$t('supervision.metric.xls.supervisor'),
      i18n.$t('supervision.metric.xls.efficiency'),
      i18n.$t('supervision.metric.xls.duration')
    ],
    [
      filters.regionName,
      moment(filters.startPeriodValue).format('DD/MM/YYYY'),
      moment(filters.endPeriodValue).format('DD/MM/YYYY'),
      filters.locationName,
      filters.supervisorName,
      filters.efficiencyPercent,
      filters.averageTime
    ],
    [''],
    [
      i18n.$t('supervision.metric.xls.route'),
      i18n.$t('supervision.metric.xls.efficiency'),
      i18n.$t('supervision.metric.xls.visitsDone'),
      i18n.$t('supervision.metric.xls.visitsPlanned'),
      i18n.$t('supervision.metric.xls.duration')
    ]
  ]

  journeys.map((journey) => {
    lines.push([journey.journey_name, Math.round(journey.efficiency, 2), journey.done, journey.total, journey.average_time || '-'])
  })

  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(lines)
  XLSX.utils.book_append_sheet(wb, ws, 'Roteiros')
  XLSX.writeFile(wb, `${i18n.$t('supervision.metric.xlsFileName')}-${filters.regionName}-${moment(filters.startPeriodValue).format('YYYYMMDD')}-${moment(filters.endPeriodValue).format('YYYYMMDD')}.xlsx`)
}
